import Vue from 'vue';
import {
  autoResize,
  alignCells,
  formatNumber
} from '@/helpers/renderHelpers';
import {
  SumNegativeRows,
} from '@/helpers/commonHelpers';
import gridProps from '@/gridProps';

export default {
  namespaced: true,
  state: {
    delivery_periods: ['month', 'day'],
    filter_measure_types: [{id: 'pcs', name: 'pieces'}, {id: 'm3', name: 'm3'}, {id: 'm2', name: 'm2'}, {id: 'lm', name: 'lm'}],
    gridOptions: {
      rowGroupPanelShow: 'always',
      animateRows: true,
      suppressColumnVirtualisation: true,
      groupHideOpenParents: true,
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        cellStyle(params) {
          return params.column.colId.includes('raw_demand_') && params.value < 0 ? {'background-color': '#FEFEEB', 'color': 'red' ,...alignCells(params)} :
              params.column.colId.includes('raw_demand_') ? {'background-color': '#FEFEEB',...alignCells(params)} :
                params.colDef.headerName.includes('_R') && typeof params.value !== 'undefined' ? {'background-color': '#FEFEEB',...alignCells(params)} :
                  alignCells(params);
        },
        valueFormatter(params) {
          return params.column.colId.includes('_m3') ? formatNumber(params.value, 3) :
            params.column.colId.includes('_pcs') ? formatNumber(params.value, 0) :
              params.column.colId.includes('_lm') || params.column.colId.includes('_m2') ? formatNumber(params.value, 2) :
                params.value
        }
      },
      aggFuncs: {
        'SumNegative': SumNegativeRows
      },
      onRowDataChanged() {
        if (this.rowData && this.rowData.length) {
          autoResize(this);
        } else {
          this.api && this.api.hideOverlay();
          this.api && this.api.showNoRowsOverlay();
        }
      },
    },
    //the collection of columns that do not affected by filters
    alwaysVisibleColumns: ['raw_tree_name', 'raw_twl', 'product_twl', 'raw_quality_name', 'product_quality_name',
      'raw_profile_name', 'product_profile_name', 'stock_address_name', 'wood_name'],
    columns: [
      {headerName: "TWL_P", field: "product_twl", colId: "product_twl", width: 130, enableRowGroup: true},
      {headerName: "Quality_P", field: "product_quality_name", colId: "product_quality_name", width: 130, enableRowGroup: true},
      {headerName: "Profile_P", field: "product_profile_name", colId: "product_profile_name", width: 130, enableRowGroup: true},
      {headerName: "ORD_P (m3)", field: "ord_based_shipped_m3", hide: true, colId: "ord_based_shipped_m3", width: 130, enableRowGroup: true, aggFunc: "sum"},
      {headerName: "ORD_P (pcs)", field: "ord_based_shipped_pcs", hide: true, colId: "ord_based_shipped_pcs", width: 130, enableRowGroup: true, aggFunc: "sum"},
      {headerName: "ORD_P (m2)", field: "ord_based_shipped_m2", hide: true, colId: "ord_based_shipped_m2", width: 130, enableRowGroup: true, aggFunc: "sum"},
      {headerName: "ORD_P (lm)", field: "ord_based_shipped_lm", hide: true, colId: "ord_based_shipped_lm", width: 130, enableRowGroup: true, aggFunc: "sum"},
      {headerName: "STOCK_P (m3)", field: "stock_product_m3", hide: true, colId: "stock_product_m3", width: 130, enableRowGroup: true, aggFunc: "sum"},
      {headerName: "STOCK_P (pcs)", field: "stock_product_pcs", hide: true, colId: "stock_product_pcs", width: 130, enableRowGroup: true, aggFunc: "sum"},
      {headerName: "STOCK_P (m2)", field: "stock_product_m2", hide: true, colId: "stock_product_m2", width: 130, enableRowGroup: true, aggFunc: "sum"},
      {headerName: "STOCK_P (lm)", field: "stock_product_lm", hide: true, colId: "stock_product_lm", width: 130, enableRowGroup: true, aggFunc: "sum"},
      {headerName: "DIFF_P (m3)", field: "diff1_m3_display", hide: true, colId: "diff1_m3_display", width: 130, enableRowGroup: true, aggFunc: "SumNegative"},
      {headerName: "DIFF_P (pcs)", field: "diff1_pcs_display", hide: true, colId: "diff1_pcs_display", width: 130, enableRowGroup: true, aggFunc: "SumNegative"},
      {headerName: "DIFF_P (m2)", field: "diff1_m2_display", hide: true, colId: "diff1_m2_display", width: 130, enableRowGroup: true, aggFunc: "SumNegative"},
      {headerName: "DIFF_P (lm)", field: "diff1_lm_display", hide: true, colId: "diff1_lm_display", width: 130, enableRowGroup: true, aggFunc: "SumNegative"},
      {headerName: "DISTR_P (m3)", field: "distr_raw_m3_in_p", hide: true, colId: "distr_raw_m3_in_p", width: 130, enableRowGroup: true, aggFunc: "sum"},
      {headerName: "DISTR_P (pcs)", field: "distr_raw_pcs_in_p", hide: true, colId: "distr_raw_pcs_in_p", width: 130, enableRowGroup: true, aggFunc: "sum"},
      {headerName: "DISTR_P (m2)", field: "distr_raw_m2_in_p", hide: true, colId: "distr_raw_m2_in_p", width: 130, enableRowGroup: true, aggFunc: "sum"},
      {headerName: "DISTR_P (lm)", field: "distr_raw_lm_in_p", hide: true, colId: "distr_raw_lm_in_p", width: 130, enableRowGroup: true, aggFunc: "sum"},
      {headerName: "DIFF_P_D (m3)", field: "diff2_m3_display", hide: true, colId: "diff2_m3_display", width: 130, enableRowGroup: true, aggFunc: "SumNegative"},
      {headerName: "DIFF_P_D (pcs)", field: "diff2_pcs_display", hide: true, colId: "diff2_pcs_display", width: 130, enableRowGroup: true, aggFunc: "SumNegative"},
      {headerName: "DIFF_P_D (m2)", field: "diff2_m2_display", hide: true, colId: "diff2_m2_display", width: 130, enableRowGroup: true, aggFunc: "SumNegative"},
      {headerName: "DIFF_P_D (lm)", field: "diff2_lm_display", hide: true, colId: "diff2_lm_display", width: 130, enableRowGroup: true, aggFunc: "SumNegative"},
      {headerName: "DIFF_R (m3)", field: "diff2_raw_m3_display", hide: true, colId: "diff2_raw_m3_display", width: 130, enableRowGroup: true, aggFunc: "SumNegative"},
      {headerName: "DIFF_R (pcs)", field: "diff2_raw_pcs_display", hide: true, colId: "diff2_raw_pcs_display", width: 130, enableRowGroup: true, aggFunc: "SumNegative"},
      {headerName: "DIFF_R (m2)", field: "diff2_raw_m2_display", hide: true, colId: "diff2_raw_m2_display", width: 130, enableRowGroup: true, aggFunc: "SumNegative"},
      {headerName: "DIFF_R (lm)", field: "diff2_raw_lm_display", hide: true, colId: "diff2_raw_lm_display", width: 130, enableRowGroup: true, aggFunc: "SumNegative"},
      {headerName: "DEMAND_R (m3)", field: "raw_demand_m3", hide: true, colId: "raw_demand_m3", width: 130, enableRowGroup: true, aggFunc: "sum"},
      {headerName: "DEMAND_R (pcs)", field: "raw_demand_pcs", hide: true, colId: "raw_demand_pcs", width: 130, enableRowGroup: true, aggFunc: "sum"},
      {headerName: "DEMAND_R (m2)", field: "raw_demand_m2", hide: true, colId: "raw_demand_m2", width: 130, enableRowGroup: true, aggFunc: "sum"},
      {headerName: "DEMAND_R (lm)", field: "raw_demand_lm", hide: true, colId: "raw_demand_lm", width: 130, enableRowGroup: true, aggFunc: "sum"},
      {headerName: "DISTR_R (m3)", field: "distr_raw_m3", hide: true, colId: "distr_raw_m3", width: 130, enableRowGroup: true, aggFunc: "sum"},
      {headerName: "DISTR_R (pcs)", field: "distr_raw_pcs", hide: true, colId: "distr_raw_pcs", width: 130, enableRowGroup: true, aggFunc: "sum"},
      {headerName: "DISTR_R (m2)", field: "distr_raw_m2", hide: true, colId: "distr_raw_m2", width: 130, enableRowGroup: true, aggFunc: "sum"},
      {headerName: "DISTR_R (lm)", field: "distr_raw_lm", hide: true, colId: "distr_raw_lm", width: 130, enableRowGroup: true, aggFunc: "sum"},
      {headerName: "TWL_R", field: "raw_twl", colId: "raw_twl", width: 130, enableRowGroup: true},
      {headerName: "Quality_R", field: "raw_quality_name", colId: "raw_quality_name", width: 130, enableRowGroup: true},
      {headerName: "Profile_R", field: "raw_profile_name", colId: "raw_profile_name", width: 130, enableRowGroup: true},
      {headerName: "Wood", field: "wood_name", colId: "wood_name", width: 130, enableRowGroup: true},
      {headerName: "Stock", field: "stock_address_name", colId: "stock_address_name", width: 130, enableRowGroup: true}
    ],
    pinnedRowInitialData: {
      diff1_m3_display: 0,
      diff1_pcs_display: 0,
      diff1_m2_display: 0,
      diff1_lm_display: 0,
      diff2_m3_display: 0,
      diff2_pcs_display: 0,
      diff2_m2_display: 0,
      diff2_lm_display: 0,
      diff2_raw_m3_display: 0,
      diff2_raw_pcs_display: 0,
      diff2_raw_m2_display: 0,
      diff2_raw_lm_display: 0,
      distr_raw_m3: 0,
      distr_raw_pcs: 0,
      distr_raw_m2: 0,
      distr_raw_lm: 0,
      distr_raw_m3_in_p: 0,
      distr_raw_pcs_in_p: 0,
      distr_raw_m2_in_p: 0,
      distr_raw_lm_in_p: 0,
      ord_based_shipped_m3: 0,
      ord_based_shipped_pcs: 0,
      ord_based_shipped_m2: 0,
      ord_based_shipped_lm: 0,
      raw_demand_m3: 0,
      raw_demand_pcs: 0,
      raw_demand_m2: 0,
      raw_demand_lm: 0,
      stock_product_m3: 0,
      stock_product_pcs: 0,
      stock_product_m2: 0,
      stock_product_lm: 0,
      sumOnlyNegativeValues: ['diff1_m3', 'diff1_pcs', 'diff1_m2', 'diff1_lm', 'diff2_m3', 'diff2_pcs', 'diff2_m2',
        'diff2_lm', 'diff2_raw_m3', 'diff2_raw_pcs', 'diff2_raw_m2', 'diff2_raw_lm']
    },
    tableData: []
  },
  getters: {
    gridOptions(state) {
      return {...gridProps,...state.gridOptions}
    }
  },
  mutations: {
    setDataForDistTable(store, data) {
      store.tableData = data;
    }
  },
  actions: {
    loadDistributionTable(store, payLoad) {
      if (store.getters.gridOptions.api) {
        store.getters.gridOptions.api.showLoadingOverlay();
      }
      Vue.http.get('production_planning/raw_distribution_table/', {params: payLoad})
        .then(response => response.json())
        .then(data => {
          store.commit('setDataForDistTable', data);
        });
    },
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/production-planning/raw-distribution/rawDistribution.js